import { CrudResource } from "@/components/CrudResource";
import { StatusBadge } from "@/components/StatusBadge";
import { DriverScoreDialog } from "@/components/DriverScoreDialog";
import { PartnerAddDriver } from "@/components/PartnerAddDriver";
import { useAuth } from "@/context/AuthContext";

const STATUS = [
  { value: "active", label: "status.active" },
  { value: "inactive", label: "status.inactive" },
  { value: "suspended", label: "status.suspended" },
];

const AVAILABILITY = [
  { value: "available", label: "status.available" },
  { value: "busy", label: "status.busy" },
  { value: "vacation", label: "status.vacation" },
  { value: "offline", label: "status.offline" },
];

const AVAIL_STYLE = {
  available: "bg-emerald-50 text-emerald-700 border border-emerald-200",
  busy: "bg-blue-50 text-blue-700 border border-blue-200",
  vacation: "bg-amber-50 text-amber-700 border border-amber-200",
  offline: "bg-slate-100 text-slate-500 border border-slate-200",
};

function AvailabilityCell({ value }) {
  const a = value || "available";
  return <span className={`text-xs px-2 py-0.5 rounded-full capitalize ${AVAIL_STYLE[a] || ""}`}>{a}</span>;
}

export default function Drivers() {
  const { user } = useAuth();
  const isPartner = user?.role === "partner";
  return (
    <CrudResource
      title="menu.drivers"
      subtitle="sub.drivers"
      endpoint="/drivers"
      testid="drivers"
      searchPlaceholder="ph.drivers"
      searchKeys={["name", "phone", "email", "partner_id", "country", "status"]}
      rowActions={user?.role === "admin" ? (row) => <DriverScoreDialog driver={row} /> : undefined}
      hideCreate={isPartner}
      extraHeader={isPartner ? <PartnerAddDriver onAdded={() => window.location.reload()} /> : undefined}
      columns={[
        { key: "name", label: "fld.name" },
        { key: "email", label: "auth.email" },
        { key: "phone", label: "auth.phone" },
        { key: "country", label: "fld.country" },
        { key: "company_name", label: "Agenzia", render: (r) => r.company_name || r.partner_name || "—" },
        { key: "active_jobs", label: "Job attivi", render: (r) => (
          <span className={`inline-flex items-center justify-center min-w-[22px] px-1.5 py-0.5 rounded-full text-xs font-semibold ${r.active_jobs > 0 ? "bg-blue-100 text-blue-800" : "bg-slate-100 text-slate-400"}`}>{r.active_jobs || 0}</span>
        ) },
        { key: "availability", label: "fld.availability", render: (r) => <AvailabilityCell value={r.availability} /> },
        { key: "status", label: "common.status", render: (r) => <StatusBadge status={r.status || "active"} /> },
      ]}
      fields={[
        { name: "name", label: "fld.name", type: "text" },
        { name: "email", label: "auth.email", type: "text" },
        { name: "phone", label: "auth.phone", type: "text" },
        { name: "license_number", label: "fld.licenseNumber", type: "text" },
        { name: "country", label: "fld.country", type: "text" },
        { name: "partner_id", label: "fld.partnerCompany", optionsEndpoint: "/partners", labelKey: "company_name" },
        { name: "status", label: "common.status", type: "select", options: STATUS },
        { name: "availability", label: "fld.availability", type: "select", options: AVAILABILITY },
        { name: "active", label: "fld.active", type: "switch" },
      ]}
      bulk={{
        statusOptions: STATUS,
        assignEndpoint: "/partners",
        actions: [
          { key: "export", kind: "export", action: "export", label: "bulk.export", roles: ["admin", "support", "partner"] },
          { key: "status", kind: "status", label: "bulk.status", roles: ["admin", "support", "partner"] },
          { key: "assign", kind: "assign", label: "bulk.assignCompany", roles: ["admin", "support"] },
          { key: "suspend", kind: "suspend", action: "suspend", label: "bulk.suspend", roles: ["admin", "support", "partner"] },
          { key: "delete", kind: "delete", action: "delete", label: "bulk.delete", roles: ["admin", "partner"] },
        ],
      }}
    />
  );
}
